export function ConcernChips({ concerns }: { concerns: string[] }) {
  if (concerns.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {concerns.map((c, i) => (
        <span
          key={i}
          className="rounded-hs-sm bg-hs-surface-alt px-2.5 py-1 text-[11.5px] font-medium text-hs-text"
        >
          {c}
        </span>
      ))}
    </div>
  );
}
